import { ConfirmDialog } from './ConfirmDialog';

interface DiscardChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
}

export function DiscardChangesDialog({ open, onOpenChange, onDiscard }: DiscardChangesDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Discard changes?"
      description="You have unsaved changes. They will be lost if you continue."
      confirmLabel="Discard"
      cancelLabel="Keep editing"
      confirmVariant="destructive"
      onConfirm={onDiscard}
    />
  );
}
